module.exports = __webpack_public_path__ + "img/thumbnail_Banner moto-Pag nueva.5d7a74e2.jpg";